import { Stack } from "@mantine/core";
import { useAppForm } from "../../hooks/preferenceForm";
import { BridgePreferences } from "./components/BridgePreferences";
import { CrownPreferences } from "./components/CrownPreferences";
import { InlayCorePreferences } from "./components/InlayCorePreferences";
import { StepPreferences } from "./components/StepPreferences";
import { getFixedPreferenceDefaults } from "./fixedPreferenceForm";

const FixedPreferences = () => {
  const form = useAppForm({
    defaultValues: getFixedPreferenceDefaults(),
  });

  return (
    <form>
      <Stack pb="s16">
        <CrownPreferences form={form} />

        <BridgePreferences form={form} />

        <InlayCorePreferences form={form} />

        <StepPreferences form={form} />
      </Stack>
    </form>
  );
};

export default FixedPreferences;
